import Axios from "axios";
import { protectedResources } from "../authConfig";

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL = protectedResources.apiHRMobile.menuApi;
let tokenKey;
// eslint-disable-next-line no-undef
if (sessionStorage.getItem("AccessToken") !== null) {
  tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
  // eslint-disable-next-line no-undef
  localStorage.setItem("AccessTokens", tokenKey);
}
const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenKey}`,
  },
};

export async function GetPermission() {
  try {
    const URL_Permission =
      process.env.REACT_APP_API_MENU_ITEMS + "/Permission/";
    console.log(URL_Permission);
    const response = await Axios.get(URL_Permission, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}


export async function AddPermissionGroup(data) {
  try {
    const URL_Permission = process.env.REACT_APP_API_MENU_ITEMS + "/Permission/" + id;
    const response = await Axios.delete(URL_Permission, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

export async function UpdatePermissionGroup(data, id) {
  try {
    const URL_Permission = process.env.REACT_APP_API_MENU_ITEMS + "/Permission/" + id;
    const response = await Axios.delete(URL_Permission, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

export async function DeletePermissionGroup(id) {
  try {
    const URL_Permission = process.env.REACT_APP_API_MENU_ITEMS + "/Permission/" + id;
    const response = await Axios.delete(URL_Permission, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}